import { Button, Col, Form, Modal, PageHeader } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BillingJob from "redux/models/billingJobs";
import { selectConfigration } from "redux/slices/configrationSlice";
import { selectUser, selectUserId } from "redux/slices/userSlice";
import K from "utilities/constants";
import LayoutCss from "layout/layout.module.scss";
import { isPermissionPresent } from "utilities/generalUtility";
import { DataTableLayout } from "../../../common/components/dataTableLayout/dataTableLayout";
import { ClientSideDataGrid } from "../../../common/components/clientSideDataGrid/clientSideDataGrid";
import { usePageFilter } from "../../../hooks/usePageFilters";
import { getColumns } from "./columns";
import AddNewBillingJob from "./addNewBillingJob";

export default function BillingJobs() {
  const dispatch = useDispatch();

  const userId = useSelector(selectUserId);
  const userSlice = useSelector(selectUser);
  const billingJobsData = useSelector(selectConfigration).billingJobs;

  const [search, setSearch] = usePageFilter("billing_jobs_search");

  const [form] = Form.useForm();
  const [pageState, setPageState] = useState({
    editData: null,
    isLoading: false,
    isModalVisible: false,
  });

  const editHandler = (record) => {
    setPageState((prev) => {
      return {
        ...prev,
        isModalVisible: true,
        editData: record,
      };
    });
  };

  const showModal = () => {
    setPageState((prev) => ({ ...prev, isModalVisible: true }));
  };

  const handleCancel = () => {
    setPageState((prev) => ({
      ...prev,
      editData: null,
      isModalVisible: false,
    }));
  };

  const handleOk = () => {
    form.submit();
  };

  const afterModalClose = () => {
    form.resetFields();
  };

  const getBillingJobsData = () => {
    return billingJobsData.map((item) => ({
      ...item,
      isAssignable: item.isAssignable ? "Assignable" : "UnAssignable",
      hasMarkup: item.hasMarkup ? "true" : "false",
      isRequired: item.isRequired ? "true" : "false",
    }));
  };

  const getAllBillings = async () => {
    try {
      await dispatch(BillingJob.getAll());
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getAllBillings();
  }, []);

  return (
    <>
      <PageHeader
        ghost={false}
        title="Job Level Configuration"
        className={LayoutCss.appPageHeader}
      />

      <DataTableLayout
        searchDefaultValue={search}
        onSearchChange={setSearch}
        actions={[
          {
            permissions: [K.Permissions.CreateJobBilling],
            renderer: () => (
              <Col>
                <Button type="primary" onClick={showModal}>
                  Add New
                </Button>
              </Col>
            ),
          },
        ]}
      >
        <ClientSideDataGrid
          userId={userId}
          configKey={K.AgGridTable.Keys.BillingJobsVisibleColumn}
          defaultColumnConfig={getColumns(userSlice.roles, editHandler)}
          rowData={getBillingJobsData()}
          quickFilterText={search}
        />
      </DataTableLayout>

      <Modal
        open={pageState.isModalVisible}
        okText={pageState.editData ? "Edit" : "Add"}
        wrapClassName="vertical-center-modal"
        closeIcon={<i className="icon-closeable" />}
        centered
        width={462}
        title={
          pageState.editData ? "Edit Configuration" : "Jobs New Configuration"
        }
        className="s2-theme-style billingClient"
        confirmLoading={pageState.isLoading}
        onOk={handleOk}
        onCancel={handleCancel}
        afterClose={afterModalClose}
        destroyOnClose
      >
        <AddNewBillingJob
          form={form}
          pageState={pageState}
          setPageState={setPageState}
          billingTypes={billingJobsData}
        />
      </Modal>
    </>
  );
}
